import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICON } from '@core/util/icon';
import {
	TitlePlusModalComponent,
	TitlePlusModalData,
} from '../title-plus-modal/title-plus-modal.component';
import { TestHooks } from './title-plus-cancelled.hooks';

@Component({
	selector: 'app-title-plus-cancelled',
	templateUrl: './title-plus-cancelled.component.html',
	styleUrls: ['./title-plus-cancelled.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TitlePlusCancelledComponent {
	testHooks = TestHooks;
	public ICON = ICON;

	constructor(private dialog: MatDialog) {}

	reactivateOrder() {
		const data: TitlePlusModalData = {
			submitNewOrder: false,
		};

		this.dialog.open(TitlePlusModalComponent, { data });
	}
}
